import {
  clearPersistedSnapshots,
  readPersistedSnapshots,
  writePersistedSnapshot,
} from './workspaceChatCachePersist.js'

/** In-memory chat snapshots while switching workspaces in one browser session. */

export function emptyWorkspaceChatSnapshot() {
  return {
    threads: [],
    messagesByThreadId: {},
    pinnedThreadIds: [],
    selectedThreadId: null,
    dismissedNoteThreadIds: [],
    activeProjectId: null,
  }
}

const snapshots = new Map()

export function readWorkspaceChatSnapshot(workspaceId) {
  if (!workspaceId) return null
  if (snapshots.has(workspaceId)) return snapshots.get(workspaceId) ?? null
  return readPersistedSnapshots()[workspaceId] ?? null
}

export function writeWorkspaceChatSnapshot(workspaceId, snapshot) {
  if (!workspaceId || !snapshot) return
  snapshots.set(workspaceId, snapshot)
  writePersistedSnapshot(workspaceId, snapshot)
}

export function snapshotFromChatModel(model) {
  return {
    threads: model.threads ?? [],
    messagesByThreadId: model.messagesByThreadId ?? {},
    pinnedThreadIds: model.pinnedThreadIds ?? [],
    selectedThreadId: model.selectedThreadId ?? null,
    dismissedNoteThreadIds: model.dismissedNoteThreadIds ?? [],
    activeProjectId: model.activeProjectId ?? null,
  }
}

export function applyWorkspaceChatSnapshot(model, snapshot) {
  model.setThreads(snapshot.threads)
  model.setMessagesByThreadId(snapshot.messagesByThreadId)
  model.setPinnedThreadIds(snapshot.pinnedThreadIds)
  model.setSelectedThreadId(snapshot.selectedThreadId)
  model.setDismissedNoteThreadIds(snapshot.dismissedNoteThreadIds)
  model.setActiveProjectId(snapshot.activeProjectId)
}

export function clearWorkspaceChatSnapshots() {
  snapshots.clear()
  clearPersistedSnapshots()
}
